import { render, staticRenderFns } from "./CityContentEdit.vue?vue&type=template&id=685537e7&"
import script from "./CityContentEdit.vue?vue&type=script&lang=js&"
export * from "./CityContentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports